<script lang="ts" generics="K extends string">
  import type { Snippet } from "svelte";
  import Button from "../Button.svelte";
  import TableHeader from "./TableHeader.svelte";

  interface Props {
    sortKey: K;
    currentSortKey: K;
    sortDir: "asc" | "desc";
    onSort: (key: K) => void;
    children: Snippet;
  }

  const { sortKey, currentSortKey, sortDir, onSort, children }: Props = $props();

  const isActive = $derived(sortKey === currentSortKey);
  const arrow = $derived(isActive ? (sortDir === "asc" ? "↑" : "↓") : "↓");
</script>

<TableHeader scope="col">
  <Button onclick={() => onSort(sortKey)} variant="unstyled">
    {@render children()}
    <span class="ml-0.5 text-xs" class:text-mono-500={!isActive}>{arrow}</span>
  </Button>
</TableHeader>
